import { foundationContext, Information } from '@philips-internal/oswald-ui-foundation';
import { getFoundationDataContext } from '../../../src/app/bootstrap-foundation';
import { ScheduleType } from './pseudonym-types';
import { APPOINTMENT_TYPE as AppointmentType } from '../../constants/appointment-type';
import { TASK_CHECKUP_LIST_VISIBILITY } from './pseudonym-enums';
import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { PredefinedValidators } from '../../utils/predefined-validators';

export default class PseudonymUtils {

  static parseScheduleTypeToAppointmentType(scheduleType: ScheduleType | string): AppointmentType {
    if (!scheduleType) {
      return AppointmentType.UNKNOW;
    }

    switch (scheduleType) {
      case ScheduleType.CHECKUP: return AppointmentType.CHECKUP;
      case ScheduleType.CHEMOTHERAPY: return AppointmentType.CHEMOTHERAPIES;
      case ScheduleType.CONSULTATION: return AppointmentType.CONSULTATIONS;
      case ScheduleType.EXAM: return AppointmentType.EXAMS;
      case ScheduleType.SERVICE: return AppointmentType.SERVICES;
      case ScheduleType.SURGERY: return AppointmentType.SURGERIES;
      default: return AppointmentType.UNKNOW;
    }
  }

  static parseAppointmentTypeToScheduleType(appointmentType: AppointmentType | string): ScheduleType {
    if (!appointmentType) {
      return ScheduleType.UNKNOW;
    }

    switch (appointmentType) {
      case AppointmentType.CHECKUP: return ScheduleType.CHECKUP;
      case AppointmentType.CHEMOTHERAPIES: return ScheduleType.CHEMOTHERAPY;
      case AppointmentType.CONSULTATIONS: return ScheduleType.CONSULTATION;
      case AppointmentType.EXAMS: return ScheduleType.EXAM;
      case AppointmentType.SERVICES: return ScheduleType.SERVICE;
      case AppointmentType.SURGERIES: return ScheduleType.SURGERY;
      default: return ScheduleType.UNKNOW;
    }
  }

  static getAppointmentTypeFromCurrentRoute(currentRoute: string): AppointmentType {
    const appointmentTypes = [
      AppointmentType.CHECKUP,
      AppointmentType.CHEMOTHERAPIES,
      AppointmentType.CONSULTATIONS,
      AppointmentType.EXAMS,
      AppointmentType.REQUEST,
      AppointmentType.SERVICES,
      AppointmentType.SURGERIES,
      AppointmentType.WAITING_LIST,
    ];

    const foundType = appointmentTypes.find(type => this.hasRoute(type, currentRoute));
    return foundType ?? AppointmentType.UNKNOW;
  }

  static setDefaultContextInformation(): void {
    const appContext = getFoundationDataContext();
    const applicationInformationDataOriginal = appContext.get('applicationInformationData') as Information;

    foundationContext.clearInformation();
    foundationContext.setInformationOnce(applicationInformationDataOriginal);
  }

  private static hasRoute(route: string, currentRoute: string): boolean {
    return currentRoute.includes(route);
  }

  static setStepCheckupListVisibility(fieldStepListApi: FieldAPI, viewField: string = TASK_CHECKUP_LIST_VISIBILITY.NOT_SHOW): void {
    switch (viewField) {
      case TASK_CHECKUP_LIST_VISIBILITY.SHOW:
        this.setFieldsConfig([fieldStepListApi], true, false);
        break;
      case TASK_CHECKUP_LIST_VISIBILITY.NOT_SHOW:
      default:
        this.setFieldsConfig([fieldStepListApi], false, false);
        break;
    }
  }

  static setFieldsConfig(fields: FieldAPI[], visible: boolean, required: boolean): void {
    const requiredValues = required && [PredefinedValidators.required()] || [];

    fields.forEach(field => {
      field.setVisible(visible);
      field.setValidators(requiredValues);
    })
  }
}
